// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__fAx6q","active":"MenuLink_active__DJpVb MenuLink_link__fAx6q","noWrap":"MenuLink_noWrap__rfOWX"};